<template>
  <div class="Footer">
    <footer class="footer">
      <div class="footer_top flex_around">
        <div class="footer_nav flex_start">
          <router-link to="/">{{ $t("nav.home") }}</router-link>
          <router-link to="/membercenter">{{
            $t("nav.menberCenter")
          }}</router-link>
          <router-link to="/goodsCenter">{{ $t("nav.proCenter") }}</router-link>
          <router-link to="/customized/apply">{{
            $t("nav.service")
          }}</router-link>
          <router-link to="/tgshare">{{ $t("nav.share") }}</router-link>
          <router-link to="/service">{{ $t("nav.afterSale") }}</router-link>
        </div>
        <div class="footer_img flex_start">
          <a
            :href="item.linkUrl"
            v-for="(item, index) in arr"
            :key="index"
            target="view_window"
          >
            <img :src="$img + item.coverImage" alt="" />
          </a>
        </div>
      </div>
      <div class="footer_bottom flex_center">
        <div class="flex_start link">
          <div>{{$t('homePage.friend')}}：</div>
          <a
            v-for="(item, index) in link"
            :key="index"
            class="name"
            :href="item.linkUrl"
            target="view_window"
            >{{ item.linkName }}</a
          >
        </div>
        <div class="flex_start link">
          {{ $t("publicText.edition") }}：copyright © 2016 - 2020
          {{ $t("publicText.txt") }}
          <a class="name" href="https://beian.miit.gov.cn" target="view_window"
            >&nbsp;&nbsp;蜀ICP备17033025号-1</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import "@/assets/css/footer.css";

export default {
  name: "Footer",
  data() {
    return {
      arr: [],
      link: [],
    };
  },
  props: {},
  methods: {
    // 获取友情链接
    getLink() {
      this.$get(`/open/friendLink/getFriendLinkAll`).then((res) => {
        if (res.code == 0) {
          this.link = res.data;
        }
      });
    },
  },
  mounted() {
    this.getLink();
    this.$get(`/open/friendLink/getFriendLinkAll`).then((res) => {
      if (res.code == 0) {
        this.arr = res.data;
      }
    });
  },
};
</script>

<style scoped>
.link .name {
  margin-right: 10px;
  color: rgba(255, 255, 255, 0.4);
}

.link {
  font-size: 12px;
  align-items: center;
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/Footer.vue